import * as React from 'react';

export const doctorHeaderIcon = (
	<svg width="28" height="29" viewBox="0 0 28 29" fill="none" xmlns="http://www.w3.org/2000/svg">
		<rect width="28" height="28" transform="translate(0 0.833008)" fill="none" />
		<path
			d="M7.56409 9.57061C7.56409 10.1738 7.56409 11.9262 8.80169 12.3526C9.8885 15.1658 11.9061 16.9702 14.0017 16.9702C16.0973 16.9702 18.1149 15.1658 19.1965 12.3526C20.4393 11.9262 20.4393 10.1738 20.4393 9.57061C20.4393 9.1078 20.2469 8.7542 19.9245 8.56181V8.54619C19.9245 4.15219 17.8757 1.83301 14.0017 1.83301C10.1225 1.83301 8.07891 4.15219 8.07891 8.54619V8.56181C7.75131 8.7542 7.56409 9.1078 7.56409 9.57061ZM8.60929 9.45619C8.6197 9.45099 8.63532 9.44578 8.65611 9.44578C8.67169 9.44578 8.6821 9.4354 8.69771 9.4354C8.72891 9.42499 8.76011 9.41979 8.78611 9.4042C8.82251 9.39379 8.85371 9.37818 8.8797 9.3626C8.9057 9.34698 8.92652 9.32619 8.95251 9.3054C8.9785 9.27941 9.0045 9.25338 9.02532 9.22219C9.0357 9.21181 9.04611 9.2014 9.05652 9.18578C9.50891 8.40578 10.2629 7.52698 10.6061 7.52698C10.8921 7.52698 11.1781 7.6154 11.5317 7.73499C12.1089 7.91698 12.8213 8.14578 13.9653 8.14578C15.1093 8.14578 15.8217 7.91698 16.3989 7.73499C16.7577 7.6154 17.0385 7.52698 17.3297 7.52698C17.6677 7.52698 18.4269 8.40578 18.8741 9.18578C18.9729 9.35739 19.1445 9.45099 19.3265 9.45099C19.3317 9.45099 19.3421 9.44578 19.3473 9.44578C19.3629 9.44578 19.3785 9.45099 19.3837 9.45099C19.3889 9.4666 19.3993 9.50301 19.3993 9.57061C19.3993 11.0526 19.0509 11.3334 18.7753 11.3906C18.5725 11.401 18.3853 11.5362 18.3177 11.7338C17.4077 14.2818 15.7125 15.9302 14.0017 15.9302C12.2857 15.9302 10.5905 14.2818 9.6857 11.7338C9.61289 11.5362 9.43611 11.4062 9.2385 11.3906C8.95771 11.3386 8.60409 11.0734 8.60409 9.57061C8.60409 9.4978 8.6145 9.4614 8.60929 9.45619Z"
			fill="#989B9C"
		/>
		<path
			d="M18.7308 22.9957C18.7308 23.5794 19.2056 24.0542 19.7891 24.0542C20.3731 24.0542 20.8479 23.5794 20.8479 22.9957C20.8479 22.4119 20.3731 21.9369 19.7891 21.9369C19.2056 21.9369 18.7308 22.4119 18.7308 22.9957Z"
			fill="#989B9C"
		/>
		<path
			d="M6.56654 27.833H21.4386C23.0921 27.833 24.4337 26.4862 24.4337 24.8326V24.1982C24.4337 21.234 22.8068 18.5125 20.3099 17.0524V20.9694C21.215 21.2023 21.8887 22.0183 21.8887 22.9951C21.8887 24.1521 20.9472 25.0936 19.7899 25.0936C18.6331 25.0936 17.6917 24.1521 17.6917 22.9951C17.6917 22.0184 18.3653 21.2025 19.2699 20.9694V16.5408C19.0308 16.4434 18.7875 16.3537 18.5369 16.2786C18.3601 16.2266 18.1625 16.2734 18.0274 16.4034C16.8157 17.5786 15.4222 18.1974 14.0025 18.1974C12.5829 18.1974 11.1893 17.5786 9.97253 16.4034C9.83736 16.2734 9.64493 16.2266 9.46294 16.2786C9.1309 16.3782 8.81177 16.504 8.5 16.6426L9.0797 19.4847C10.203 19.551 11.3886 20.6672 12.2291 22.5071C12.5069 23.1149 12.5221 23.7987 12.2692 24.336C12.0869 24.7234 11.7792 24.9926 11.4024 25.0941C11.1256 25.1685 10.8397 25.0042 10.7651 24.727C10.6905 24.4497 10.855 24.1643 11.1322 24.0897C11.2303 24.0633 11.2932 23.9683 11.3283 23.8934C11.4486 23.6372 11.4314 23.2627 11.2836 22.9392C10.5605 21.3569 9.51487 20.3489 8.79733 20.5413C8.0803 20.734 7.68166 22.131 7.84924 23.8627C7.88377 24.2166 8.05643 24.5492 8.28901 24.7105C8.35756 24.7582 8.46014 24.8095 8.55764 24.7821C8.83389 24.7069 9.1203 24.8717 9.19494 25.1492C9.26959 25.4265 9.10506 25.7119 8.8278 25.7865C8.72014 25.8155 8.61045 25.8297 8.50077 25.8297C8.22553 25.8297 7.94877 25.7398 7.6969 25.5654C7.20889 25.2274 6.87881 24.6285 6.81432 23.9632C6.61599 21.9163 7.1019 20.3341 8.06989 19.7359L7.54116 17.1435C5.13165 18.6227 3.56616 21.2902 3.56616 24.1982V24.8326C3.56616 26.4862 4.91294 27.833 6.56654 27.833Z"
			fill="#989B9C"
		/>
	</svg>
);

export const doctorContentIcon = (
	<svg width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M40.625 60.9375H59.375V77.3438H40.625V60.9375Z" fill="url(#paint0_linear_339_20224)" />
		<path
			d="M40.625 70.3115C42.7633 72.5881 46.1664 74.2178 50 74.2178C53.9211 74.2178 57.2477 72.6771 59.375 70.3115V99.9998H50H40.625V70.3115Z"
			fill="url(#paint1_linear_339_20224)"
		/>
		<path
			d="M40.625 70.3115C42.7633 72.5881 46.1664 74.2178 50 74.2178C53.9211 74.2178 57.2477 72.6771 59.375 70.3115C60.2406 70.5029 61.3117 70.7615 62.5195 71.0732C60.7023 74.7225 55.7906 77.3428 50 77.3428C44.2094 77.3428 39.2977 74.7225 37.4805 71.0732C38.6883 70.7615 39.7594 70.5037 40.625 70.3115Z"
			fill="url(#paint2_linear_339_20224)"
		/>
		<path
			d="M27.3438 78.9055L13.2812 77.3438C13.2812 77.3438 5.46875 85.1562 1.5625 100H27.3438V78.9055Z"
			fill="url(#paint3_linear_339_20224)"
		/>
		<path
			d="M37.5 69.5312C31.9305 70.7648 17.8992 73.957 13.2812 77.3438L21.0938 100H46.875L37.5 69.5312Z"
			fill="url(#paint4_linear_339_20224)"
		/>
		<path
			d="M72.6562 78.9055L86.7188 77.3438C86.7188 77.3438 94.5312 85.1562 98.4375 100H72.6562V78.9055Z"
			fill="url(#paint5_linear_339_20224)"
		/>
		<path
			d="M62.5 69.5312C68.0695 70.7648 82.1008 73.957 86.7188 77.3438L78.9062 100H53.125L62.5 69.5312Z"
			fill="url(#paint6_linear_339_20224)"
		/>
		<path
			d="M78.125 42.857C78.125 46.3086 75.6766 50 72.6562 50C69.6359 50 67.1875 46.3086 67.1875 42.857C67.1875 39.4055 69.6359 37.5 72.6562 37.5C75.6766 37.5 78.125 39.4055 78.125 42.857Z"
			fill="url(#paint7_linear_339_20224)"
		/>
		<path
			d="M32.0312 42.857C32.0312 46.3086 29.5828 50 26.5625 50C23.5422 50 21.0938 46.3086 21.0938 42.857C21.0938 39.4055 23.5422 37.5 26.5625 37.5C29.5828 37.5 32.0312 39.4055 32.0312 42.857Z"
			fill="url(#paint8_linear_339_20224)"
		/>
		<path
			d="M69.5312 23.4375H30.4688C28.7203 23.8617 27.3438 25.5445 27.3438 27.3438V42.9742C27.3438 56.25 37.5 66.4062 50 66.4062C62.5 66.4062 72.6562 56.25 72.6562 42.9742V27.3438C72.6562 25.5391 71.2867 23.857 69.5312 23.4375Z"
			fill="url(#paint9_linear_339_20224)"
		/>
		<path
			d="M50 3.125C62.2539 3.125 75.7812 12.6469 75.7812 27.3438C75.7406 36.65 72.6562 42.9688 72.6562 42.9688C72.6562 38.2812 70.3125 27.3438 70.3125 27.3438C57.0312 30.4688 30.4688 24.2188 30.4688 24.2188C30.4688 24.2188 27.3438 28.9062 27.3438 42.9688C27.3438 42.9688 22.6562 37.5 22.6562 28.125C22.6562 16.4344 28.125 14.0625 28.125 14.0625C28.125 14.0625 29.6875 3.125 50 3.125Z"
			fill="url(#paint10_linear_339_20224)"
		/>
		<path
			d="M49.9866 60.9368C48.221 60.9368 46.4601 60.3681 44.8601 59.2321C44.5085 58.9821 44.4257 58.4946 44.6757 58.1423C44.9257 57.7899 45.4132 57.7087 45.7655 57.9579C48.4398 59.8587 51.528 59.8579 54.2398 57.9556C54.5921 57.7071 55.0804 57.7931 55.328 58.1462C55.5757 58.4993 55.4905 58.9868 55.1374 59.2345C53.5194 60.3689 51.7507 60.9368 49.9866 60.9368Z"
			fill="url(#paint11_linear_339_20224)"
		/>
		<path
			d="M39.8438 46.0938C41.1382 46.0938 42.1875 45.0444 42.1875 43.75C42.1875 42.4556 41.1382 41.4062 39.8438 41.4062C38.5493 41.4062 37.5 42.4556 37.5 43.75C37.5 45.0444 38.5493 46.0938 39.8438 46.0938Z"
			fill="url(#paint12_linear_339_20224)"
		/>
		<path
			d="M60.1562 46.0938C61.4507 46.0938 62.5 45.0444 62.5 43.75C62.5 42.4556 61.4507 41.4062 60.1562 41.4062C58.8618 41.4062 57.8125 42.4556 57.8125 43.75C57.8125 45.0444 58.8618 46.0938 60.1562 46.0938Z"
			fill="url(#paint13_linear_339_20224)"
		/>
		<path
			d="M44.5303 37.4945C44.3889 37.4945 44.2467 37.4562 44.1178 37.3765C39.7749 34.6726 36.946 36.4914 35.7382 37.2687L35.5741 37.3742C35.2085 37.6046 34.7264 37.4953 34.496 37.1312C34.2655 36.7664 34.3741 36.2843 34.7389 36.0531L34.8936 35.9546C36.2249 35.0976 39.7639 32.8242 44.9444 36.0507C45.3108 36.2789 45.4225 36.7609 45.1944 37.1265C45.046 37.364 44.7913 37.4945 44.5303 37.4945V37.4945Z"
			fill="url(#paint14_linear_339_20224)"
		/>
		<path
			d="M55.4699 37.495C55.2089 37.495 54.9542 37.3645 54.8058 37.127C54.5777 36.7606 54.6894 36.2785 55.0558 36.0512C60.237 32.8231 63.7753 35.0989 65.1074 35.9551L65.2613 36.0535C65.6261 36.284 65.7339 36.7668 65.5042 37.1317C65.2738 37.4965 64.7909 37.6051 64.4261 37.3746L64.262 37.27C63.055 36.4934 60.2245 34.6739 55.8816 37.3778C55.7534 37.4567 55.6113 37.495 55.4699 37.495V37.495Z"
			fill="url(#paint15_linear_339_20224)"
		/>
		<path
			d="M49.9969 53.9059C49.9953 53.9059 49.9945 53.9059 49.993 53.9059C49.2313 53.9043 48.4961 53.5489 47.8672 52.8778C47.5727 52.5629 47.5883 52.0684 47.9031 51.7731C48.218 51.4793 48.7125 51.4942 49.0078 51.809C49.236 52.052 49.5922 52.3426 49.9953 52.3434H49.9969C50.4031 52.3434 50.7633 52.052 50.9946 51.8067C51.2906 51.4926 51.7852 51.4785 52.0992 51.7746C52.4125 52.0707 52.4274 52.5653 52.1313 52.8793C51.4969 53.5512 50.7594 53.9059 49.9969 53.9059V53.9059Z"
			fill="url(#paint16_linear_339_20224)"
		/>
		<path
			d="M40.625 67.1875L46.875 100L34.375 88.2812L35.9375 82.0312L30.4688 81.2492L36.7188 69.5305C37.3531 68.3828 39.1602 67.1883 40.625 67.1875Z"
			fill="url(#paint17_linear_339_20224)"
		/>
		<path
			d="M59.375 67.1875L53.125 100L65.625 88.2812L64.0625 82.0312L69.5312 81.2492L63.2812 69.5305C62.6469 68.3828 60.8398 67.1883 59.375 67.1875Z"
			fill="url(#paint18_linear_339_20224)"
		/>
		<path
			d="M36.7188 94.5312H32.8125C32.3813 94.5312 32.0312 94.182 32.0312 93.75C32.0312 93.318 32.3813 92.9688 32.8125 92.9688H36.7188C37.5805 92.9688 38.2812 92.268 38.2812 91.4062V83.5938C38.2812 79.7164 35.1266 76.5625 31.25 76.5625C27.3734 76.5625 24.2188 79.7164 24.2188 83.5938V91.4062C24.2188 92.268 24.9195 92.9688 25.7812 92.9688H28.9062C29.3375 92.9688 29.6875 93.318 29.6875 93.75C29.6875 94.182 29.3375 94.5312 28.9062 94.5312H25.7812C24.0578 94.5312 22.6562 93.1297 22.6562 91.4062V83.5938C22.6562 78.8555 26.5117 75 31.25 75C35.9883 75 39.8438 78.8555 39.8438 83.5938V91.4062C39.8438 93.1297 38.4422 94.5312 36.7188 94.5312Z"
			fill="url(#paint19_linear_339_20224)"
		/>
		<path
			d="M31.25 75C26.5117 75 22.6562 78.8555 22.6562 83.5938H24.2188C24.2188 79.7164 27.3734 76.5625 31.25 76.5625C35.1266 76.5625 38.2812 79.7164 38.2812 83.5938H39.8438C39.8438 78.8555 35.9883 75 31.25 75Z"
			fill="url(#paint20_linear_339_20224)"
		/>
		<path
			d="M28.9062 92.9688H27.3438V94.5312H28.9062C29.3375 94.5312 29.6875 94.182 29.6875 93.75C29.6875 93.318 29.3375 92.9688 28.9062 92.9688Z"
			fill="url(#paint21_linear_339_20224)"
		/>
		<path
			d="M32.8125 92.9688H34.375V94.5312H32.8125C32.3813 94.5312 32.0312 94.182 32.0312 93.75C32.0312 93.318 32.3813 92.9688 32.8125 92.9688Z"
			fill="url(#paint22_linear_339_20224)"
		/>
		<path
			d="M62.4852 62.6064C61.6867 63.1439 60.8531 63.6307 59.9883 64.0627H60.9359C66.9672 64.0627 71.8734 68.9689 71.8734 75.0002V84.3752C71.8734 84.8072 72.2234 85.1564 72.6547 85.1564C73.0859 85.1564 73.4359 84.8072 73.4359 84.3752V75.0002C73.4359 68.6338 68.6477 63.3736 62.4852 62.6064Z"
			fill="url(#paint23_linear_339_20224)"
		/>
		<path
			d="M37.5633 62.6396C33.5383 63.3514 30.4688 66.867 30.4688 71.0936V75.7811C30.4688 76.2131 30.8188 76.5623 31.25 76.5623C31.6812 76.5623 32.0312 76.2131 32.0312 75.7811V71.0936C32.0312 67.2162 35.1859 64.0623 39.0625 64.0623C39.2695 64.0623 39.4555 63.9787 39.5953 63.8467C38.8961 63.4795 38.218 63.0771 37.5633 62.6396Z"
			fill="url(#paint24_linear_339_20224)"
		/>
		<path
			d="M72.6562 91.4062C74.8136 91.4062 76.5625 89.6574 76.5625 87.5C76.5625 85.3426 74.8136 83.5938 72.6562 83.5938C70.4989 83.5938 68.75 85.3426 68.75 87.5C68.75 89.6574 70.4989 91.4062 72.6562 91.4062Z"
			fill="url(#paint25_linear_339_20224)"
		/>
		<path
			d="M72.6562 91.4062C74.8136 91.4062 76.5625 89.6574 76.5625 87.5C76.5625 85.3426 74.8136 83.5938 72.6562 83.5938C70.4989 83.5938 68.75 85.3426 68.75 87.5C68.75 89.6574 70.4989 91.4062 72.6562 91.4062Z"
			fill="url(#paint26_linear_339_20224)"
		/>
		<path d="M68.75 83.5938H76.5625V91.4062H68.75V83.5938Z" fill="url(#paint27_linear_339_20224)" />
		<path
			d="M72.6562 92.1875C70.0711 92.1875 67.9688 90.0852 67.9688 87.5C67.9688 84.9148 70.0711 82.8125 72.6562 82.8125C75.2414 82.8125 77.3438 84.9148 77.3438 87.5C77.3438 90.0852 75.2414 92.1875 72.6562 92.1875ZM72.6562 84.375C70.9328 84.375 69.5312 85.7766 69.5312 87.5C69.5312 89.2234 70.9328 90.625 72.6562 90.625C74.3797 90.625 75.7812 89.2234 75.7812 87.5C75.7812 85.7766 74.3797 84.375 72.6562 84.375Z"
			fill="url(#paint28_linear_339_20224)"
		/>
		<defs>
			<linearGradient
				id="paint0_linear_339_20224"
				x1="50"
				y1="74.8695"
				x2="50"
				y2="66.6664"
				gradientUnits="userSpaceOnUse"
			>
				<stop stop-color="#F6CFBE" />
				<stop offset="1" stop-color="#EDAD99" />
			</linearGradient>
			<linearGradient
				id="paint1_linear_339_20224"
				x1="49.3391"
				y1="60.3732"
				x2="49.1352"
				y2="52.7201"
				gradientUnits="userSpaceOnUse"
			>
				<stop stop-color="#FFCF97" />
				<stop offset="1" stop-color="#FFAC6A" />
			</linearGradient>
			<linearGradient
				id="paint2_linear_339_20224"
				x1="51.6594"
				y1="43.142"
				x2="50.8781"
				y2="56.2928"
				gradientUnits="userSpaceOnUse"
			>
				<stop stop-color="#FFCF97" />
				<stop offset="1" stop-color="#FFAC6A" />
			</linearGradient>
			<linearGradient
				id="paint3_linear_339_20224"
				x1="12.2977"
				y1="120.721"
				x2="14.9687"
				y2="95.0508"
				gradientUnits="userSpaceOnUse"
			>
				<stop stop-color="#EFF0F0" />
				<stop offset="1" stop-color="#E4E5E6" />
			</linearGradient>
			<linearGradient
				id="paint4_linear_339_20224"
				x1="27.0281"
				y1="114.902"
				x2="24.5727"
				y2="136.021"
				gradientUnits="userSpaceOnUse"
			>
				<stop stop-color="#EFF0F0" />
				<stop offset="1" stop-color="#E4E5E6" />
			</linearGradient>
			<linearGradient
				id="paint5_linear_339_20224"
				x1="87.7031"
				y1="120.721"
				x2="85.032"
				y2="95.0508"
				gradientUnits="userSpaceOnUse"
			>
				<stop stop-color="#EFF0F0" />
				<stop offset="1" stop-color="#E4E5E6" />
			</linearGradient>
			<linearGradient
				id="paint6_linear_339_20224"
				x1="72.9719"
				y1="114.902"
				x2="75.4273"
				y2="136.021"
				gradientUnits="userSpaceOnUse"
			>
				<stop stop-color="#EFF0F0" />
				<stop offset="1" stop-color="#E4E5E6" />
			</linearGradient>
			<linearGradient
				id="paint7_linear_339_20224"
				x1="72.6563"
				y1="20.0523"
				x2="72.6563"
				y2="58.0789"
				gradientUnits="userSpaceOnUse"
			>
				<stop stop-color="#F6CFBE" />
				<stop offset="1" stop-color="#EDAD99" />
			</linearGradient>
			<linearGradient
				id="paint8_linear_339_20224"
				x1="26.5625"
				y1="20.0523"
				x2="26.5625"
				y2="58.0789"
				gradientUnits="userSpaceOnUse"
			>
				<stop stop-color="#F6CFBE" />
				<stop offset="1" stop-color="#EDAD99" />
			</linearGradient>
			<linearGradient
				id="paint9_linear_339_20224"
				x1="53.7945"
				y1="16.5391"
				x2="55.943"
				y2="5.40625"
				gradientUnits="userSpaceOnUse"
			>
				<stop stop-color="#F6CFBE" />
				<stop offset="1" stop-color="#EDAD99" />
			</linearGradient>
			<linearGradient
				id="paint10_linear_339_20224"
				x1="49.2187"
				y1="-11.9141"
				x2="49.2187"
				y2="53.0852"
				gradientUnits="userSpaceOnUse"
			>
				<stop stop-color="#957E7F" />
				<stop offset="1" stop-color="#373638" />
			</linearGradient>
			<linearGradient
				id="paint11_linear_339_20224"
				x1="50.9468"
				y1="44.4048"
				x2="50.5562"
				y2="50.2642"
				gradientUnits="userSpaceOnUse"
			>
				<stop stop-color="#F6CFBE" />
				<stop offset="1" stop-color="#EDAD99" />
			</linearGradient>
			<linearGradient
				id="paint12_linear_339_20224"
				x1="39.6531"
				y1="69.1414"
				x2="39.7508"
				y2="56.1539"
				gradientUnits="userSpaceOnUse"
			>
				<stop stop-color="#58595B" />
				<stop offset="1" stop-color="#414042" />
			</linearGradient>
			<linearGradient
				id="paint13_linear_339_20224"
				x1="59.9648"
				y1="69.2562"
				x2="60.0625"
				y2="56.268"
				gradientUnits="userSpaceOnUse"
			>
				<stop stop-color="#58595B" />
				<stop offset="1" stop-color="#414042" />
			</linearGradient>
			<linearGradient
				id="paint14_linear_339_20224"
				x1="39.5303"
				y1="78.3859"
				x2="39.6608"
				y2="61.0687"
				gradientUnits="userSpaceOnUse"
			>
				<stop stop-color="#58595B" />
				<stop offset="1" stop-color="#414042" />
			</linearGradient>
			<linearGradient
				id="paint15_linear_339_20224"
				x1="59.8417"
				y1="78.5395"
				x2="59.9722"
				y2="61.2215"
				gradientUnits="userSpaceOnUse"
			>
				<stop stop-color="#58595B" />
				<stop offset="1" stop-color="#414042" />
			</linearGradient>
			<linearGradient
				id="paint16_linear_339_20224"
				x1="32.0055"
				y1="56.2754"
				x2="38.2071"
				y2="55.0059"
				gradientUnits="userSpaceOnUse"
			>
				<stop stop-color="#F6CFBE" />
				<stop offset="1" stop-color="#EDAD99" />
			</linearGradient>
			<linearGradient
				id="paint17_linear_339_20224"
				x1="46.7914"
				y1="125.441"
				x2="45.2453"
				y2="118.398"
				gradientUnits="userSpaceOnUse"
			>
				<stop stop-color="#EFF0F0" />
				<stop offset="1" stop-color="#E4E5E6" />
			</linearGradient>
			<linearGradient
				id="paint18_linear_339_20224"
				x1="53.2094"
				y1="125.441"
				x2="54.7555"
				y2="118.398"
				gradientUnits="userSpaceOnUse"
			>
				<stop stop-color="#EFF0F0" />
				<stop offset="1" stop-color="#E4E5E6" />
			</linearGradient>
			<linearGradient
				id="paint19_linear_339_20224"
				x1="32.4008"
				y1="100.728"
				x2="32.2242"
				y2="98.6805"
				gradientUnits="userSpaceOnUse"
			>
				<stop stop-color="#D0D3D3" />
				<stop offset="1" stop-color="#AAAEB1" />
			</linearGradient>
			<linearGradient
				id="paint20_linear_339_20224"
				x1="28.6172"
				y1="62.2594"
				x2="28.8125"
				y2="63.8219"
				gradientUnits="userSpaceOnUse"
			>
				<stop stop-color="#58595B" />
				<stop offset="1" stop-color="#414042" />
			</linearGradient>
			<linearGradient
				id="paint21_linear_339_20224"
				x1="28.5961"
				y1="95.0539"
				x2="28.5813"
				y2="94.8805"
				gradientUnits="userSpaceOnUse"
			>
				<stop stop-color="#58595B" />
				<stop offset="1" stop-color="#414042" />
			</linearGradient>
			<linearGradient
				id="paint22_linear_339_20224"
				x1="33.1227"
				y1="95.0539"
				x2="33.1375"
				y2="94.8805"
				gradientUnits="userSpaceOnUse"
			>
				<stop stop-color="#58595B" />
				<stop offset="1" stop-color="#414042" />
			</linearGradient>
			<linearGradient
				id="paint23_linear_339_20224"
				x1="65.2797"
				y1="57.6768"
				x2="65.475"
				y2="59.2393"
				gradientUnits="userSpaceOnUse"
			>
				<stop stop-color="#58595B" />
				<stop offset="1" stop-color="#414042" />
			</linearGradient>
			<linearGradient
				id="paint24_linear_339_20224"
				x1="34"
				y1="61.5865"
				x2="34.1953"
				y2="63.149"
				gradientUnits="userSpaceOnUse"
			>
				<stop stop-color="#58595B" />
				<stop offset="1" stop-color="#414042" />
			</linearGradient>
			<linearGradient
				id="paint25_linear_339_20224"
				x1="80.6023"
				y1="90.3195"
				x2="82.4945"
				y2="90.9906"
				gradientUnits="userSpaceOnUse"
			>
				<stop stop-color="#6C6F73" />
				<stop offset="1" stop-color="#56585B" />
			</linearGradient>
			<linearGradient
				id="paint26_linear_339_20224"
				x1="57.382"
				y1="85.4688"
				x2="63.5023"
				y2="86.2828"
				gradientUnits="userSpaceOnUse"
			>
				<stop stop-color="#58595B" />
				<stop offset="1" stop-color="#414042" />
			</linearGradient>
			<linearGradient
				id="paint27_linear_339_20224"
				x1="57.382"
				y1="85.4688"
				x2="63.5023"
				y2="86.2828"
				gradientUnits="userSpaceOnUse"
			>
				<stop stop-color="#6C6F73" />
				<stop offset="1" stop-color="#56585B" />
			</linearGradient>
			<linearGradient
				id="paint28_linear_339_20224"
				x1="57.382"
				y1="85.4688"
				x2="63.5023"
				y2="86.2828"
				gradientUnits="userSpaceOnUse"
			>
				<stop stop-color="#D0D3D3" />
				<stop offset="1" stop-color="#AAAEB1" />
			</linearGradient>
		</defs>
	</svg>
);

export const medical_insurance = (
	<svg width="146" height="121" viewBox="0 0 146 121" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M179.983 53.4722C180.319 40.9722 175.703 28.3645 166.136 18.8245C147.651 0.391847 117.68 0.391847 99.1939 18.8245L92.5002 25.4995L85.8064 18.8245C67.3205 0.391847 37.3496 0.391847 18.8641 18.8245C0.378629 37.2571 0.378629 67.1423 18.8641 85.5753L92.5002 159L110.909 140.644"
			stroke="white"
			strokeOpacity="0.6"
			strokeWidth="10"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M47 81.5005H72.7781L92.1114 56L111.445 107L130.778 81.5005H163"
			stroke="white"
			strokeWidth="10"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);
